/**
 * Represents the type of direct answer.
 *
 * @public
 */
export var DirectAnswerType;
(function (DirectAnswerType) {
    /** Indicates that the DirectAnswer is a {@link FeaturedSnippetDirectAnswer}. */
    DirectAnswerType["FeaturedSnippet"] = "FEATURED_SNIPPET";
    /** Indicates that the DirectAnswer is a {@link FieldValueDirectAnswer}. */
    DirectAnswerType["FieldValue"] = "FIELD_VALUE";
})(DirectAnswerType || (DirectAnswerType = {}));
//# sourceMappingURL=DirectAnswerType.js.map